import Helmet from 'react-helmet';
import type { ReactNode, VoidFunctionComponent } from 'react';

import { useIsSecurityEnabled } from '../../helpers/features/security';
import { PolicyType } from '../../types';
import Loader from '../generic/Loader';
import NotFound from '../generic/NotFound';
import type { AsyncStatus } from '../../types';

type ListSecurityPoliciesPageProps = {
  renderPolicyList: (policyType: PolicyType) => ReactNode;
  status: AsyncStatus,
};

const ListSecurityPoliciesPage: VoidFunctionComponent<ListSecurityPoliciesPageProps> = ({
  renderPolicyList,
  status,
}) => {
  const hasSecurity = useIsSecurityEnabled();
  if (!hasSecurity) {
    return <NotFound />;
  }

  return (
    <div className="container margin-top">
      <Helmet title="Policies" />
      {status?.errors?.map(error => <div className="alert alert-error">{error}</div>)}
      {status?.loading ? <Loader /> : renderPolicyList(PolicyType.SECURITY)}
    </div>
  );
};

export default ListSecurityPoliciesPage;
